<template>
  <div class="container">
    <QueryFrame
      customed-text="库存调整"
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      @handleCustomed='addAdjust'
      :count= 'count'
      :current="page"
      :showEmptyLine="true"
    >
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <lk-modal
    :mask-closable="false"
    v-model="showAdjust"
    width="420"
    title="库存调整"
    >
    <div>
      <lk-form :model="adjustQuery"
      :rules="adjustValidate"
      ref="adjustRef"
      :label-width='90'
      label-position="right">
        <lk-form-item label="商品编码：" prop="serialCode">
          <lk-input placeholder="请输入" clearable v-model="adjustQuery.serialCode"></lk-input>
        </lk-form-item>
        <lk-form-item label="批次：" prop="batchCode">
          <lk-input placeholder="请输入" clearable v-model="adjustQuery.batchSeq"></lk-input>
        </lk-form-item>
        <lk-form-item label="批号：" prop="batchSeq">
          <lk-input placeholder="请输入" clearable v-model="adjustQuery.batchCode"></lk-input>
        </lk-form-item>
        <lk-form-item label="入库日期：" prop="entryDate">
          <timeStampDatePicker v-model="adjustQuery.entryDate" :options='createTimeStartOption'></timeStampDatePicker>
        </lk-form-item>
        <lk-form-item label="有效期：" prop="expiryDate">
          <timeStampDatePicker v-model="adjustQuery.expiryDate" :options='expireTimeStartOption'></timeStampDatePicker>
        </lk-form-item>
        <lk-form-item label="调整数量	：" prop="num">
          <DtpInputNumber
            v-model.trim="adjustQuery.num"
            placeholder="请输入" class="item" style="width:300px;" clearable
            :min="-1000000000"
            :max="1000000000"
            :precision="0">
          </DtpInputNumber>
        </lk-form-item>
      </lk-form>
    </div>
    <div slot="footer">
        <div>
          <lk-button @click="cancelAdjust">取消</lk-button>
          <lk-button type="primary" @click="saveAdjust" :loading="adjustLoading">提交</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
  </template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import toolsService from '../../../services/lgq/services';
import DtpInputNumber from '../../../components/DtpInputNumber';

export default {
  name: 'drugInventoryAdjustList',
  mixins: [mapState, queryMixins],
  data() {
    return {
      adjustLoading: false,
      showAdjust: false,
      size: 20,
      adjustQuery: {
        serialCode: '',
        batchCode: '',
        batchSeq: '',
        entryDate: '',
        expiryDate: '',
        num: 0,
      },
      query: {},
      columns: [
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '通用名', key: 'approvedName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '单位', key: 'minPkgUnit', minWidth: 116 },
        { title: '数量', key: 'num', minWidth: 80 },
        { title: '批号', key: 'batchCode', minWidth: 116 },
        { title: '批次', key: 'batchSeq', minWidth: 116 },
        {
          title: '有效期',
          key: 'expiryDate',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.expiryDate)),
        },
        {
          title: '入库日期',
          key: 'entryDate',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.entryDate)),
        },
        {
          title: '调整时间',
          key: 'modifiedTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.modifiedTime)),
        },
        { title: '调整人', key: 'modifiedUserName', minWidth: 116 },
      ],
      tableData: [],
      createTimeStartOption: this.createTimeStartOptions(),
      expireTimeStartOption: this.expireTimeStartOptions(),
      adjustValidate: {
        serialCode: [{
          required: true, message: '请输入商品编码', trigger: 'blur', type: 'string',
        }],
        batchCode: [{
          required: true, message: '请输入批次', trigger: 'blur', type: 'string',
        }],
        batchSeq: [{
          required: true, message: '请输入批号', trigger: 'blur', type: 'string',
        }],
        entryDate: [{
          required: true, message: '请选择入库日期', trigger: 'blur', type: 'date',
        }],
        expiryDate: [{
          required: true, message: '请选择有效期', trigger: 'blur', type: 'date',
        }],
        num: [{
          required: true, message: '请输入调整数量', trigger: 'blur', type: 'number',
        }],
      },
    };
  },
  methods: {
    createTimeStartOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > new Date();
        },
      };
    },
    expireTimeStartOptions() {
      return {
        disabledDate(time) {
          return time.getTime() < new Date();
        },
      };
    },
    addAdjust() {
      this.showAdjust = true;
    },
    getData() {
      const params = utils.deepClone(this.query);
      params.page = this.page;
      params.size = this.size;
      toolsService.inventoryAdjustList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list;
          this.count = res.data.data.count || 0;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    saveAdjust() {
      this.$refs.adjustRef.validate((msg) => {
        if (msg) {
          this.adjustLoading = true;
          const params = utils.deepClone(this.adjustQuery);
          toolsService.inventoryAdjust(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('调整成功');
              this.getData();
            } else {
              this.$Message.error(res.data.error);
            }
            this.clearAdjust();
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
    cancelAdjust() {
      this.clearAdjust();
    },
    gotoHandleSearch() {
      this.handleSearch();
    },
    clear() {
      this.query = {};
    },
    clearAdjust() {
      this.showAdjust = false;
      this.adjustLoading = false;
      this.adjustQuery = {
        serialCode: '',
        batchCode: '',
        batchSeq: '',
        entryDate: '',
        expiryDate: '',
        num: 0,
      };
    },
  },
  mounted() {
    this.handleSearch(true);
  },
  components: {
    QueryFrame,
    DtpInputNumber,
  },
};
</script>

<style scoped>
</style>
